
import '@/lib/typedef';
import client from '@/lib/http-client';
import { buildQuery } from '@/lib/helper';

const endpoint = '/marketplace';

// Auth Shopee
export const auth = (platform, storeLabel, cb, errorCb) => {
	const url = `${endpoint}/shopee/auth?platform=${platform}&store_label=${storeLabel}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

// Integrate Shopee
export const integrateShopee = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/shop/integrate?code=${params.code}&store_label=${params.storeLabel}&shop_id=${params.shopId}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

// Get List Shop
export const getListShop = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/shop?`;
	client
		.get(url, { params })
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};
// Check Supplier
export const checkSupplier = (supplierId, params, cb, errorCb) => {
	const url = `${endpoint}/shopee/shop/check-supplier/${supplierId}`;
	client
		.get(url, { params })
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

export const getShopDetails = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/shop/get-by-shop-id`;
	client
		.post(url, params)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

export const refreshToken = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/refresh-token`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) {
				cb(response.data);
			}
		})
		.catch((e) => {
			if (errorCb) {
				errorCb(e);
			}
		});
};

/**
 *
 * Delete Shop Tokopedia Omnichannel
 *
 * @param {Object} payload
 * @param {String} payload.id
 * @param {requestCallback} cb
 * @param {requestCallback} errorCb
 * @private {String} url
 */
export const deleteShop = (payload, cb, errorCB) => {
	const url = `${endpoint}/shopee/shop/${payload.id}`;
	client
		.delete(url)
		.then((res) => {
			cb(res.data);
		})
		.catch((e) => {
			errorCB(e);
		});
};

// Get List Product By Shop
export const getListProduct = (params, cb, errorCb) => {
	const query = buildQuery(params);
	const url = `${endpoint}/shopee/product?${query}`;
	client
		.get(url)
		.then((response) => {
			cb(response.data);
		})
		.catch((e) => {
			errorCb(e);
		});
};

// Sync Product
export const syncProduct = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product/sync`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) {
				cb(response.data);
			}
		})
		.catch((e) => {
			if (errorCb) {
				errorCb(e);
			}
		});
};

// Import Product
export const importProduct = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product/import`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) {
				cb(response.data);
			}
		})
		.catch((e) => {
			if (errorCb) {
				errorCb(e);
			}
		});
};

// Get Category
export const getAllCategory = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product/category?`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Get Category
export const getAllAttribute = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product/attribute?`;
	client
		.get(url, { params })
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};

// Add Product to Shopee
export const addProduct = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) {
				cb(response.data);
			}
		})
		.catch((e) => {
			if (errorCb) {
				errorCb(e);
			}
		});
};

// Export Product
export const exportProduct = (params, cb, errorCb) => {
	const url = `${endpoint}/shopee/product/export`;
	client
		.post(url, params)
		.then((response) => {
			if (cb) {
				cb(response.data);
			}
		})
		.catch((e) => {
			if (errorCb) {
				errorCb(e);
			}
		});
};
